import { LDContext, LDSingleKindContext, useLDClient } from '@launchdarkly/react-sdk';

import { CredentialType, IAuthSite, User } from '../logic/api';

export { useLDClient }

class UserContext implements LDSingleKindContext {
  public readonly kind = 'user'
  public readonly key: string;
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly credentialType: string;

  public constructor(user: User) {
    this.key = user.uuid;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.credentialType = CredentialType[user.credentialType];
  }
}

class OperationContext implements LDSingleKindContext {
  public readonly kind = 'operation'
  public readonly key: string;
  public readonly clientCode: string;
  public readonly operationCode: string;

  public constructor(site: IAuthSite) {
    this.key = `${site.tenant.id}/${site.home.code}`;
    this.clientCode = site.tenant.code;
    this.operationCode = site.home.code;
  }
}

export function getLDContext(userA: User | null, authSite: IAuthSite): LDContext {
  const user: LDSingleKindContext | { kind: 'user'; anonymous: true } = userA
    ? new UserContext(userA)
    : { kind: 'user', anonymous: true };

  if (authSite.home) {
    const tenant = new OperationContext(authSite);
    return { kind: 'multi', user, tenant };
  }

  return { kind: 'multi', user };
}
